var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('alert',{attrs:{"clickable":"clickable","type":"warning"},on:{"click":function($event){return _vm.$router.push({ name: 'third-party-tokens' })}}},[[_vm._v("Create a ScholarPack Rest token")]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66181414","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/appsList/cards/admin/ScholarPackCreateTokenNotice.vue
// module id = null
// module chunks = 